const routes = {
    AUTH: '/auth',
    REGISTER: '/register',
    HOME: '/home',
    SHOP: '/shop',
    SUMMARY: '/summary',
    PROFILE: '/profile',
    ALL: '/'
}
export default routes;